/**
 * Product detail blocks — variant-aware swapping via the theme's Section Rendering.
 *
 * On variant change the theme (product-info.js) already fetches this section for
 * the selected variant and publishes PUB_SUB_EVENTS.variantChange with the parsed
 * section HTML in event.data.html. We read the freshly-rendered blocks from there
 * (no extra request) and swap them in when the new variant has cards. If the
 * variant has no blocks we keep whatever is currently shown.
 */
(function () {
  function init() {
    const container = document.querySelector('[data-pdp-detail-blocks]');
    if (!container) return;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const html = event && event.data && event.data.html;
      if (!html) return;

      const fresh = html.querySelector('[data-pdp-detail-blocks]');
      // Only swap when the new variant actually rendered cards; otherwise keep previous.
      if (fresh && fresh.querySelector('.pdp-detail-card')) {
        container.innerHTML = fresh.innerHTML;
        container.classList.remove('pdp-detail-blocks--empty');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
